import { useLocation, useNavigate } from "react-router-dom";
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { ModuloState, setModulo } from '../../store/slices/modulo/moduloSlice';
import { CursoState } from "../../store/slices/curso";
// LaTeX
import Latex from 'react-latex-next';
// mui components
import Divider from "@mui/material/Divider";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from "@mui/material/ListItemButton";
// mui icons
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

type Props = {
    curso: CursoState
    modulos: Array<ModuloState>
}

const Sidebar = ({ curso, modulos }: Props) => {

    const dispatch = useDispatch<AppDispatch>();

    const { usuario } = useSelector((state: RootState) => state.usuario);

    const navigate = useNavigate();
    const { pathname } = useLocation();
    
    const handleRoute = (modulo: ModuloState) => {
        // console.log(modulo)
        navigate(`/curso/${curso?.sigla}/${modulo.modulo}`);
        dispatch(setModulo(modulo))
    }

    return (
        <>
            <List sx={{px: 1, position: 'relative', bottom: 0, backgroundColor: 'black'}}>
                <ListItem 
                    sx={{color: 'white', cursor: 'pointer'}} 
                    onClick={() => navigate('/inicio')}
                >
                    <ListItemIcon sx={{color: 'white'}}>
                        <AccountBalanceIcon/>
                    </ListItemIcon>
                    {/* <ListItemText primary={`${curso.sigla}`} /> */}
                    <ListItemText primary='CURSO' />
                </ListItem>
            </List>
            <div className="sidebar">
                <Divider sx={{color: 'white', p: 0, m: 0}} />
                
                <List sx={{px: 1}}>
                    {
                        [
                            {
                                cid: '', 
                                mid: '',
                                modulo: 0,
                                nombre: 'Noticias'
                            }
                        ].concat(modulos).map(item => {
                            const { mid, modulo, nombre } = item;
                            return (
                                <ListItem 
                                    key={mid}
                                    disablePadding
                                    className='listItem'
                                    sx={`/curso/${curso?.sigla}/${modulo}` !== pathname ? {
                                            width: '100%',
                                            borderRadius: '5px',
                                            marginBottom: '0.5em',
                                            marginTop: '0.5em',
                                            transition: '0.3s linear all',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: 'rgba(24, 62, 138, 0.4)',
                                                color: 'white',
                                                transition: '0.3s linear all'
                                            },
                                        } : {
                                            width: '100%',
                                            borderRadius: '5px',
                                            marginBottom: '0.5em',
                                            marginTop: '0.5em',
                                            backgroundColor: 'rgb(24, 62, 138)',
                                            color: 'white',
                                            cursor: 'inherit',
                                            transition: '0.3s linear all',
                                            '&:hover': {
                                                width: '100%',
                                                borderRadius: '5px',
                                                marginBottom: '0.5em',
                                                marginTop: '0.5em',
                                                backgroundColor: 'rgb(24, 62, 138)',
                                                color: 'white',
                                                cursor: 'inherit',
                                                transition: '0.3s linear all',
                                            },
                                        }
                                    }
                                >
                                    <ListItemButton 
                                        sx={{borderRadius: '5px'}}
                                        role={undefined} 
                                        onClick={() => handleRoute(item)} 
                                    >
                                        <ListItemIcon sx={{color: 'white'}}>
                                            {
                                                modulo === 0 ? 
                                                <i className="fa-solid fa-newspaper"></i> :
                                                <div 
                                                    style={{ 
                                                        background: 'white', 
                                                        color: 'black', 
                                                        borderRadius: '5px', 
                                                        width: '23px', 
                                                        height: '23px', 
                                                        textAlign: 'center', 
                                                        fontWeight: 'bold', 
                                                        verticalAlign: 'middle'
                                                    }}
                                                >
                                                    {modulo}
                                                </div>
                                            }
                                            
                                        </ListItemIcon>
                                        <ListItemText  primary={<Latex>{nombre}</Latex>} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })
                    }
                </List>
            </div>
            <List sx={{px: 1, position: 'relative', bottom: 0, backgroundColor: 'black'}}>
                
                <ListItem 
                    sx={{
                        width: 220,
                        borderRadius: '5px',
                        marginBottom: '0.5em',
                        marginTop: '0.5em',
                        transition: '0.3s linear all',
                        color: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    }}
                >
                    <ListItemIcon sx={{color: 'white'}}>
                        <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary={`${usuario.nombre} ${usuario.apellido}`} />
                </ListItem>
            </List>
        
        </>
        
    )
}

export default Sidebar